import { Box, Typography, useTheme } from '@mui/material';

import { Merchant } from '@trendiolive/trendio-selfcare-ui-kit';

import MerchantAvatar from 'components/MerchantAvatar';

type UserMerchantListItemProps = Readonly<{
  merchant?: Merchant | null;
  onClick: (id: string) => Promise<void>;
}>;

export default function UserMerchantListItem({ merchant, onClick }: UserMerchantListItemProps) {
  const theme = useTheme();
  return (
    <Box
      onClick={() => onClick(merchant?.id ?? '')}
      sx={{
        px: 2.5,
        py: 1,
        ':hover': {
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.primary.lighter,
          cursor: 'pointer'
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 0.5 }}>
        <MerchantAvatar {...{ merchant: merchant ?? null }} size={32} sx={{ fontSize: '0.875rem' }} />
        <Typography variant="button">{merchant?.name}</Typography>
      </Box>
    </Box>
  );
}
